const config = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:19303572-76a9-4a21-9fc2-a548b5ce61aa",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_AoOC7UPws",
    "aws_user_pools_web_client_id": "741khrfs6hbgfs6ddlmconl1tu",
    "aws_user_pools_web_client_redirect_url": "https://console.prod.nissan.eu/admin-console-portal-module/index.html",
    "aws_user_pools_domain_url": "backend-vms-prod.auth.eu-west-1.amazoncognito.com",
    "aws_user_files_s3_bucket": "nissan-console-deposit-prod",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "aws_content_delivery_bucket": "nissan-console-hosting-prod",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://console.prod.nissan.eu",
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "cdn_api": "https://inventory-dealers.prod.nissan.eu",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "co-bo-users-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "co-bo-usersaudit-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "core-bo-countries-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "core-bo-dealerref-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "core-bo-rolesref-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "core-bo-rolesref-v2-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "core-keystore-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-email-status-eu-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-email-status-gb-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-email-status-no-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-lead-order-state-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-lead-status-eu-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-lead-status-gb-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-lead-status-no-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-price-mappings-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-scheduled-email-status-eu-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-scheduled-email-status-gb-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-scheduled-email-status-no-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-spec-bootstrap-eims-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-upsell-conf-db",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom-vms-marketing-labels",
            "region": "eu-west-1"
        },
        {
            "tableName": "ecom_inventory_nissan_qa_automation_sm_tests_results",
            "region": "eu-west-1"
        },
        {
            "tableName": "frds-fr-vms-discounts",
            "region": "eu-west-1"
        },
        {
            "tableName": "frds-fr-vms-inventory-guid",
            "region": "eu-west-1"
        },
        {
            "tableName": "frds-fr-vms-process-management",
            "region": "eu-west-1"
        },
        {
            "tableName": "frds-fr-vms-process-management-backup",
            "region": "eu-west-1"
        },
        {
            "tableName": "frds-fr-vms-ref-asset",
            "region": "eu-west-1"
        },
        {
            "tableName": "frds-fr-vms-ref-color",
            "region": "eu-west-1"
        },
        {
            "tableName": "frds-fr-vms-ref-engine",
            "region": "eu-west-1"
        },
        {
            "tableName": "frds-fr-vms-ref-grade",
            "region": "eu-west-1"
        },
        {
            "tableName": "frds-fr-vms-ref-modelcode",
            "region": "eu-west-1"
        },
        {
            "tableName": "mainboard_subscription",
            "region": "eu-west-1"
        },
        {
            "tableName": "retention-tagging-errors",
            "region": "eu-west-1"
        },
        {
            "tableName": "user-security-log",
            "region": "eu-west-1"
        },
        {
            "tableName": "vms-dealer-move",
            "region": "eu-west-1"
        },
        {
            "tableName": "vms-dealer-skip",
            "region": "eu-west-1"
        },
        {
            "tableName": "vms-ei-assets",
            "region": "eu-west-1"
        },
        {
            "tableName": "vms-ei-details",
            "region": "eu-west-1"
        },
        {
            "tableName": "vms-model-year",
            "region": "eu-west-1"
        },
        {
            "tableName": "vms-ref-co2",
            "region": "eu-west-1"
        },
        {
            "tableName": "vms-ref-configurator-url",
            "region": "eu-west-1"
        },
        {
            "tableName": "vms-ref-efficiency",
            "region": "eu-west-1"
        },
        {
            "tableName": "vms-ref-fuel",
            "region": "eu-west-1"
        },
        {
            "tableName": "vms-ref-packs-options",
            "region": "eu-west-1"
        },
        {
            "tableName": "vms-ref-transmission",
            "region": "eu-west-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "MainboardV2API",
            "endpoint": "https://49dhdz2l62.execute-api.eu-west-1.amazonaws.com/release/",
            "region": "eu-west-1",
            "apiKey": "arWKabHgxDawecoxCs2Y429tbp9VrXu9gf2ELcM6"
        },
        {
            "name": "nissan_CDR_API",
            "endpoint": "https://a1apk82auk.execute-api.eu-west-1.amazonaws.com/release/",
            "region": "eu-west-1",
            "apiKey": "slpLtVw2f48l4iwrVXEJkaRFK3ey8OmN3Lrjvyhz"
        },
        {
            "name": "user_actions_API",
            "endpoint": "https://al3f1vt9a0.execute-api.eu-west-1.amazonaws.com/release/",
            "region": "eu-west-1",
            "apiKey": "ZFeCf07w0t66qjajeIE7D17LTgSGMtCu9GxkbkGn"
        },
        {
            "name": "CDR_Prod",
            "endpoint": "https://cijsn40jcb.execute-api.eu-west-1.amazonaws.com/release/",
            "region": "eu-west-1"
        },
        {
            "name": "frds_vms_fr_process_management_API",
            "endpoint": "https://g3gu0jcbka.execute-api.eu-west-1.amazonaws.com/release/",
            "region": "eu-west-1",
            "apiKey": "AMZ8e6vdFqaiAUAlLIYj03ID2RVjuXMV4SR1dpOZ"
        },
        {
            "name": "Nissan_Leads_API",
            "endpoint": "https://kjmcgd8czb.execute-api.eu-west-1.amazonaws.com/release/",
            "region": "eu-west-1",
            "apiKey": "1H1CFtLSQjCsoBd0QegT7hIn92VU1YB5PupODaL9"
        },
        {
            "name": "ecom_core_keystore_API",
            "endpoint": "https://ld50ym0gia.execute-api.eu-west-1.amazonaws.com/release/",
            "region": "eu-west-1",
            "apiKey": "miUeqm7ARr2W2pvUbodlQ3DscBLct01j13WLrlhN"
        },
        {
            "name": "ecom_dealer_admin_API",
            "endpoint": "https://n7l1prfs93.execute-api.eu-west-1.amazonaws.com/release/",
            "region": "eu-west-1",
            "apiKey": "aeByYh96uw3Ex12CEXWcXKrSCmUNg4S9CH9sIzv8"
        },
        {
            "name": "inventory-latest-stockfile-api",
            "endpoint": "https://oynlnoqn47.execute-api.eu-west-1.amazonaws.com/release/",
            "region": "eu-west-1",
            "apiKey": "vabPkfqll54aOZF3rySFx65JlUcIVUnF8OJA1Q0B"
        },
        {
            "name": "formulae_core_API",
            "endpoint": "https://p5h6etngwc.execute-api.eu-west-1.amazonaws.com/release/",
            "region": "eu-west-1"
        },
        {
            "name": "storyblok-assets-api",
            "endpoint": "https://rwyxtzba70.execute-api.eu-west-1.amazonaws.com/release/",
            "region": "eu-west-1"
        }
    ],
    "auth_api": "https://bo.prod.kube.nissan.eu"
};
export default config;